/**
 * Oduree -> land en taal
 * ----------------------
 * Twee domeinen, twee talen:
 *   oduree.nl  -> Nederlands (markt Nederland & België)
 *   oduree.com -> Engels (markt Worldwide)
 *
 * 1. Kiest een bezoeker een land in de landkiezer, dan sturen we land en taal in
 *    één verzoek mee (Shopify /localization), zodat de taal altijd past bij het domein.
 * 2. De taalkiezer (snippets/localization-selector.liquid) toont alleen Nederlands en
 *    English. De taal die niet op dit domein staat, is een knop met
 *    data-oduree-language-host. Die knop gaat naar dezelfde pagina op het andere
 *    domein, via de hreflang-link die Shopify zelf in de pagina zet (met de vertaalde
 *    handle). Zonder zo'n link: hetzelfde pad op het andere domein.
 * 3. Munt: elk land rekent in zijn eigen munt (Shopify Markets, lokale valuta aan). Het land gaat
 *    mee als ?country=XX; Shopify kiest daar de munt bij.
 * 5. Het venster voor land, munt en taal (snippets/oduree-locatiekiezer.liquid) roept
 *    window.OdureeLocatie.kies(land, taal) aan: dezelfde pagina in die taal en dat land, en de keuze
 *    wordt onthouden (ook over de domeinen heen via ?odu-keuze).
 * 4. Op locatie: het land komt van Shopify zelf (browsing_context_suggestions, op IP; het verzoek
 *    start al in layout/theme.liquid). Nederland gaat naar oduree.nl, de rest van de wereld naar
 *    oduree.com in de taal van zijn land (/de, /fr, /es, /it, /pt-pt, /pl), anders Engels.
 *    Meertalige landen (Zwitserland, Luxemburg, België, Canada) volgen de browsertaal.
 *    Niet als de bezoeker zelf een taal of land koos, niet voor zoekmachines, niet als de bezoeker
 *    al iets aanklikt, en hooguit één keer per bezoek. Land en munt gaan in hetzelfde verzoek mee.
 *    Testen: ?odu-land=ES (doet alsof de bezoeker uit dat land komt).
 * 6. Zelf gekozen taal: wie eerder zelf een taal koos (venster, taalknop of ?odu-keuze) en later op de Engelse
 *    hoofdversie van oduree.com binnenkomt (zonder taalmap), gaat één keer per bezoek naar dezelfde pagina in
 *    die taal (zie naarGekozenTaal). De locatie speelt dan geen rol meer.
 */
(function () {
  'use strict';

  var HOSTS = { nl: 'https://oduree.nl', en: 'https://oduree.com' };
  var COUNTRY_TO_LOCALE = { NL: ['nl', 'en'], BE: ['nl', 'en'] };
  var MANUAL_COUNTRY_KEY = 'oduree_manual_country_code';
  var MANUAL_LOCALE_KEY = 'oduree_manual_locale';
  /* Talen die op oduree.com volledig vertaald zijn; alleen daarheen sturen we door. */
  var ROUTE_LANGS = ['de', 'fr', 'es', 'it', 'pt-pt', 'pl', 'sv', 'da', 'nb', 'fi', 'cs', 'hu', 'ro', 'el', 'ar'];
  /* Land -> talen; de eerste is de standaard, de browsertaal kan een andere uit het rijtje kiezen.
     Landen die er niet in staan: Engels op oduree.com. */
  var COUNTRY_LANG = {
    NL: ['nl'], BE: ['nl', 'fr'],
    DE: ['de'], AT: ['de'], LI: ['de'], CH: ['de', 'fr', 'it'], LU: ['fr', 'de'],
    IT: ['it'], SM: ['it'], VA: ['it'], PL: ['pl'],
    SE: ['sv'], AX: ['sv', 'fi'], DK: ['da'], FO: ['da'], GL: ['da'], NO: ['nb'], SJ: ['nb'], BV: ['nb'], FI: ['fi', 'sv'],
    CZ: ['cs'], HU: ['hu'], RO: ['ro'], MD: ['ro'], GR: ['el'], CY: ['el'],
    /* Spaans: Spanje en heel Spaanstalig Amerika. In de VS beslist de browsertaal (standaard Engels). */
    ES: ['es'], AD: ['es'], EA: ['es'], IC: ['es'], GQ: ['es', 'fr', 'pt-pt'],
    MX: ['es'], GT: ['es'], HN: ['es'], SV: ['es'], NI: ['es'], CR: ['es'], PA: ['es'], CU: ['es'], DO: ['es'],
    PR: ['es', 'en'], CO: ['es'], VE: ['es'], EC: ['es'], PE: ['es'], BO: ['es'], CL: ['es'], AR: ['es'],
    PY: ['es'], UY: ['es'], US: ['en', 'es'],
    /* Portugees (Portugal) voor alle Portugeestalige landen, ook Brazilië. */
    PT: ['pt-pt'], BR: ['pt-pt'], AO: ['pt-pt'], MZ: ['pt-pt'], CV: ['pt-pt'], GW: ['pt-pt'], ST: ['pt-pt'], TL: ['pt-pt'],
    /* Frans: Frankrijk met overzeese gebieden, Franstalig Afrika en Haïti. Canada en Mauritius volgen de browser. */
    FR: ['fr'], MC: ['fr'], CA: ['en', 'fr'],
    GF: ['fr'], GP: ['fr'], MQ: ['fr'], RE: ['fr'], YT: ['fr'], PM: ['fr'], BL: ['fr'], MF: ['fr'],
    NC: ['fr'], PF: ['fr'], WF: ['fr'], TF: ['fr'], HT: ['fr'],
    SN: ['fr'], CI: ['fr'], ML: ['fr'], BF: ['fr'], NE: ['fr'], TG: ['fr'], BJ: ['fr'], GN: ['fr'], CM: ['fr', 'en'],
    GA: ['fr'], CG: ['fr'], CD: ['fr'], CF: ['fr'], TD: ['fr', 'ar'], MG: ['fr'], BI: ['fr'],
    SC: ['en', 'fr'], MU: ['en', 'fr'],
    /* Arabisch: in de Golfstaten spreekt een groot deel Engels, dus daar beslist de browsertaal (standaard Engels).
       In de Maghreb en Libanon mag de browser ook Frans kiezen. */
    SA: ['ar'], EG: ['ar'], JO: ['ar'], LB: ['ar', 'fr'], IQ: ['ar'], SY: ['ar'], MA: ['ar', 'fr'], DZ: ['ar', 'fr'],
    TN: ['ar', 'fr'], LY: ['ar'], YE: ['ar'], SD: ['ar'], PS: ['ar'], MR: ['ar', 'fr'], SO: ['ar'], DJ: ['fr', 'ar'],
    KM: ['ar', 'fr'], EH: ['ar'],
    AE: ['en', 'ar'], QA: ['en', 'ar'], KW: ['en', 'ar'], BH: ['en', 'ar'], OM: ['en', 'ar']
  };
  /* Landen van oduree.nl (markt Nederland & België): die zetten we op oduree.com niet als land. */
  var NL_LANDEN = { NL: true, BE: true };
  var ROUTE_KEY = 'oduree_route_done';
  var KEUZE_ROUTE_KEY = 'oduree_keuze_route_done';
  var GEO_KEY = 'oduree_geo';

  function currentHost() {
    return (location.hostname || '').toLowerCase().replace(/^www\./, '');
  }

  function getAvailableLocales() {
    var buttons = document.querySelectorAll('button[name="locale_code"]');
    var locales = [];
    for (var i = 0; i < buttons.length; i++) {
      var v = buttons[i].value;
      if (v && locales.indexOf(v) === -1) locales.push(v);
    }
    if (locales.length > 0) return locales;
    return currentHost() === 'oduree.nl' ? ['nl'] : ['en'];
  }

  function resolveLocale(countryCode, availableLocales) {
    var huidig = (document.documentElement.lang || '').toLowerCase();
    var preferences = (COUNTRY_TO_LOCALE[countryCode] || (COUNTRY_LANG[countryCode] || []).slice(0, 1)).concat([huidig, 'en']);
    for (var i = 0; i < preferences.length; i++) {
      if (availableLocales.indexOf(preferences[i]) !== -1) return preferences[i];
    }
    return availableLocales[0] || null;
  }

  function ensureHiddenInput(form, name, value) {
    var inp = form.querySelector('input[name="' + name + '"][data-oduree-pair]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = name;
      inp.setAttribute('data-oduree-pair', '1');
      form.appendChild(inp);
    }
    inp.value = value;
  }

  function getStoredManualCountry() {
    try {
      return window.localStorage && window.localStorage.getItem(MANUAL_COUNTRY_KEY);
    } catch (err) {
      return '';
    }
  }

  function storeManualCountry(country) {
    try {
      if (window.localStorage && country) {
        window.localStorage.setItem(MANUAL_COUNTRY_KEY, String(country).toUpperCase());
      }
    } catch (err) {}
  }

  function onCountryClick(e) {
    var btn = e.target.closest('button[name="country_code"]');
    if (!btn) return;
    var country = btn.value;
    if (!country) return;

    var available = getAvailableLocales();
    var locale = resolveLocale(country, available);
    if (!locale) return;
    storeManualCountry(country);

    var form = btn.closest('form');
    if (!form) return;

    var htmlLang = (document.documentElement.lang || '').toLowerCase().split('-')[0];

    // Altijd onderscheppen, zodat country_code en locale_code in hetzelfde verzoek meegaan,
    // ook als een x-listbox/AJAX-handler de knop anders zou afvangen.
    e.preventDefault();
    e.stopImmediatePropagation();

    ensureHiddenInput(form, 'country_code', country);
    if (htmlLang !== locale) ensureHiddenInput(form, 'locale_code', locale);

    try { form.submit(); }
    catch (err) {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
    }
  }

  /* dezelfde pagina op het andere domein: eerst de hreflang-link van Shopify, anders hetzelfde pad */
  function otherDomainUrl(targetLocale) {
    var base = HOSTS[targetLocale];
    if (!base) return null;
    var links = document.querySelectorAll('link[rel="alternate"][hreflang]');
    for (var i = 0; i < links.length; i++) {
      var lang = (links[i].getAttribute('hreflang') || '').toLowerCase();
      var href = links[i].getAttribute('href') || '';
      if ((lang === targetLocale || lang.indexOf(targetLocale + '-') === 0) && href.indexOf(base) === 0) return metKeuze(href, targetLocale);
    }
    var path = (location.pathname || '/').replace(/^\/(de|fr|es|it|pt-pt|pl|en|sv|da|nb|fi|cs|hu|ro|el|ar|nl)(\/|$)/, '/');
    if (path !== '/' && path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
    return metKeuze(base + path + location.search, targetLocale);
  }

  /* Eigen keuze meegeven naar het andere domein, zodat de locatie de bezoeker daar niet terugstuurt. */
  function metKeuze(href, taal) {
    try { var u = new URL(href); u.searchParams.set('odu-keuze', taal); return u.toString(); } catch (err) { return href; }
  }

  /* ---------- Op locatie (zie punt 4 bovenaan) ---------- */

  var IS_BOT = /bot|crawl|spider|slurp|mediapartners|lighthouse|headless|preview/i;
  var TEST_LAND = (location.search.match(/[?&]odu-land=([A-Za-z]{2})/) || [])[1];
  var aangeraakt = false; /* klikt of typt de bezoeker al, dan sturen we niet meer door */
  ['pointerdown', 'keydown'].forEach(function (t) {
    document.addEventListener(t, function () { aangeraakt = true; }, { capture: true, once: true });
  });

  function opslag(soort, sleutel, waarde) {
    try {
      var s = window[soort];
      if (waarde === undefined) return s.getItem(sleutel);
      s.setItem(sleutel, waarde);
      return true;
    } catch (err) { return null; }
  }

  function huidigeTaal() {
    if (currentHost() === 'oduree.nl') return 'nl';
    return String((window.ODUREE_LOCALIZATION_STATE || {}).locale || 'en').toLowerCase();
  }

  /* De browsertalen op volgorde van voorkeur, bijv. ['fr-ch', 'fr', 'en']. */
  function browserTalen() {
    var l = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
    return Array.prototype.map.call(l, function (x) { return String(x).toLowerCase(); });
  }

  /* De taal voor dit land: de eerste browsertaal die het land kent, anders de standaard van het land. */
  function doelTaal(land) {
    var kandidaten = COUNTRY_LANG[land];
    if (!kandidaten) return 'en';
    var talen = browserTalen();
    for (var i = 0; i < talen.length; i++) {
      for (var k = 0; k < kandidaten.length; k++) {
        if (talen[i] === kandidaten[k] || talen[i].split('-')[0] === kandidaten[k].split('-')[0]) return kandidaten[k];
      }
    }
    return kandidaten[0];
  }

  /* Het land dat we op oduree.com instellen: eigen land bij de euro of een eigen munt, anders Ierland (euro). */
  /* Het land dat we op oduree.com instellen, met de eigen munt van dat land. Nederland en België horen bij
     oduree.nl: ?country=NL of BE op oduree.com stuurt Shopify door naar oduree.nl. Wie daar toch op oduree.com
     wil blijven (bijv. een Franstalige Belg op /fr), krijgt Ierland: ook euro, en geen omleiding. */
  function doelLand(land) {
    if (!land) return null;
    return NL_LANDEN[land] ? 'IE' : land;
  }

  /* Dezelfde pagina in de doeltaal: de hreflang-link die Shopify zelf in de pagina zet (met de vertaalde
     handle). Shopify zet het land in de code (de-DE, es-DE), dus we herkennen de taal aan het domein en pad. */
  function linkVoor(taal) {
    var links = document.querySelectorAll('link[rel="alternate"][hreflang]');
    var taalPad = /^https:\/\/oduree\.com\/(de|fr|es|it|pt-pt|pl|sv|da|nb|fi|cs|hu|ro|el|ar|en)(\/|\?|$)/;
    for (var j = 0; j < links.length; j++) {
      var href = links[j].getAttribute('href') || '';
      if (taal === 'nl' && href.indexOf('https://oduree.nl') === 0) return href;
      if (taal === 'en' && href.indexOf('https://oduree.com') === 0 && !taalPad.test(href)) return href;
      var basis = 'https://oduree.com/' + taal;
      if (href === basis || href.indexOf(basis + '/') === 0 || href.indexOf(basis + '?') === 0) return href;
    }
    return null;
  }

  function metParams(href, params) {
    var url;
    try { url = new URL(href, location.href); } catch (err) { return null; }
    /* De eigen zoekparameters van de bezoeker (bijv. een kortingslink of utm) gaan mee. */
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k !== 'odu-land' && k !== 'country' && !url.searchParams.has(k)) url.searchParams.set(k, v);
    });
    Object.keys(params).forEach(function (k) { url.searchParams.set(k, params[k]); });
    url.hash = location.hash;
    return url.toString();
  }

  /* Bepaalt waar de bezoeker heen moet; geeft een URL terug, of null als hij goed zit. */
  function bestemming(land) {
    var nu = huidigeTaal();
    var taal = doelTaal(land);
    if (taal !== 'nl' && taal !== 'en' && (ROUTE_LANGS.indexOf(taal) === -1 || !linkVoor(taal))) taal = 'en';
    /* Engels is de terugval: wie al op een taalversie van oduree.com zit (bijv. via Google), halen we daar niet weg. */
    if (taal === 'en' && nu !== 'nl') taal = nu;
    /* Ook naar oduree.nl gaan de zoekparameters (kortingslink, utm, gclid) en de #-link van de bezoeker mee. */
    if (taal === 'nl') { if (nu === 'nl') return null; var nlHref = linkVoor('nl'); return nlHref ? metParams(nlHref, {}) : null; }
    var state = window.ODUREE_LOCALIZATION_STATE || {};
    var land2 = doelLand(land);
    var landKlopt = currentHost() === 'oduree.com' && String(state.country || '').toUpperCase() === land2;
    if (taal === nu && landKlopt) return null;
    var href = taal === nu && currentHost() === 'oduree.com' ? location.href : linkVoor(taal);
    if (!href) return null;
    /* ?country= zet land en munt in dezelfde stap (Shopify onthoudt het daarna zelf). */
    return metParams(href, { country: land2 });
  }

  function vasteKeuze() {
    if (TEST_LAND) return false;
    return !!(opslag('localStorage', MANUAL_LOCALE_KEY) || opslag('localStorage', MANUAL_COUNTRY_KEY));
  }

  /* Zelf gekozen taal (punt 6 bovenaan): wie eerder zelf een taal koos en later op de Engelse hoofdversie van
     oduree.com binnenkomt (zonder taalmap, bijv. oduree.com/ getypt), gaat naar dezelfde pagina in die taal.
     Veilig gehouden: alleen op oduree.com in het Engels, alleen bij een bekende taalcode als opgeslagen keuze, niet
     voor zoekmachines, niet als de bezoeker al klikt of typt, en hooguit één keer per bezoek: wie daarna zelf
     naar het Engels gaat, blijft daar. Een nieuwe eigen keuze overschrijft de opgeslagen keuze (kies() en de
     taalknoppen), dus we sturen nooit tegen de laatste keuze in. Geeft true terug als we doorsturen. */
  function naarGekozenTaal() {
    if (TEST_LAND || IS_BOT.test(navigator.userAgent || '') || aangeraakt) return false;
    if (currentHost() !== 'oduree.com' || huidigeTaal() !== 'en') return false;
    var taal = String(opslag('localStorage', MANUAL_LOCALE_KEY) || '').toLowerCase();
    if (taal !== 'nl' && ROUTE_LANGS.indexOf(taal) === -1) return false;
    if (opslag('sessionStorage', KEUZE_ROUTE_KEY)) return false;
    var href = linkVoor(taal);
    if (!href) return false; /* deze pagina bestaat niet in die taal: blijven */
    /* Land en munt zoals de bezoeker ze zelf koos. Nederland en België horen bij oduree.nl; op oduree.com staan ze als
       Ierland (zelfde euro). Naar oduree.nl gaat de keuze mee, zodat de locatie daar niet terugstuurt. */
    var land = String(opslag('localStorage', MANUAL_COUNTRY_KEY) || '').toUpperCase();
    var params = {};
    if (taal === 'nl') {
      params['odu-keuze'] = 'nl';
      if (NL_LANDEN[land]) params.country = land;
    } else if (/^[A-Z]{2}$/.test(land)) {
      params.country = doelLand(land);
    }
    var url = metParams(href, params);
    if (!url || url === location.href) return false;
    /* De vlag pas zetten als we echt doorsturen: een pagina zonder versie in die taal (404, zoeken) gebruikt de
       doorsturing van dit bezoek niet op. Zonder opslag geen 'één keer per bezoek', dus dan niet doorsturen. */
    if (opslag('sessionStorage', KEUZE_ROUTE_KEY, '1') !== true) return false;
    window.location.replace(url);
    return true;
  }

  /* Haalt het land op (start al in theme.liquid) en stuurt zo nodig door. Geeft true terug als we doorsturen. */
  function routeByLocation(klaar) {
    if (!TEST_LAND && IS_BOT.test(navigator.userAgent || '')) return klaar(false);
    if (vasteKeuze()) return klaar(naarGekozenTaal());
    if (!TEST_LAND && opslag('sessionStorage', ROUTE_KEY)) return klaar(false);
    if (opslag('sessionStorage', ROUTE_KEY, '1') !== true) return klaar(false); /* zonder opslag geen keuze te onthouden */

    var gaan = function (land) {
      land = String(land || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(land) || aangeraakt) return klaar(false);
      var url = bestemming(land);
      if (!url || url === location.href) return klaar(false);
      window.location.replace(url);
      return klaar(true);
    };

    if (TEST_LAND) return gaan(TEST_LAND);
    var bewaard = opslag('sessionStorage', GEO_KEY);
    if (bewaard) return gaan(bewaard === '-' ? '' : bewaard);
    var vraag = window.ODUREE_GEO || (window.fetch
      ? fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (j) { return (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || ''; })
      : null);
    if (!vraag) return klaar(false);
    var klaarGemeld = false;
    var eenmaal = function (land) { if (klaarGemeld) return; klaarGemeld = true; gaan(land); };
    /* Duurt het te lang, dan niet meer verspringen terwijl de bezoeker al leest. */
    setTimeout(function () { aangeraakt = true; eenmaal(''); }, 2500);
    vraag.then(function (land) { opslag('sessionStorage', GEO_KEY, land || '-'); eenmaal(land); }, function () { eenmaal(''); });
  }

  /* ?country=, ?odu-land= en ?odu-keuze= uit de adresbalk halen zodra Shopify het land heeft overgenomen.
     odu-keuze komt mee als de bezoeker zelf naar het andere domein ging: dan ook daar zijn keuze onthouden. */
  (function () {
    if (!/[?&](country|odu-land|odu-keuze|odu-thuis)=/.test(location.search) || !window.history || !history.replaceState) return;
    try {
      var url = new URL(location.href);
      if (url.searchParams.has('odu-keuze')) opslag('localStorage', MANUAL_LOCALE_KEY, url.searchParams.get('odu-keuze') || '1');
      if (/^[A-Za-z]{2}$/.test(url.searchParams.get('odu-thuis') || '')) opslag('localStorage', MANUAL_COUNTRY_KEY, url.searchParams.get('odu-thuis').toUpperCase());
      url.searchParams.delete('odu-thuis');
      url.searchParams.delete('country');
      url.searchParams.delete('odu-land');
      url.searchParams.delete('odu-keuze');
      history.replaceState(history.state, '', url.toString());
    } catch (err) {}
  })();

  /* Het venster voor land, munt en taal (punt 5 bovenaan). taal is een Shopify-code (nl, en, de, pt-PT ...). */
  function kies(land, taal) {
    land = String(land || '').toUpperCase();
    taal = String(taal || 'en');
    var pad = taal.toLowerCase();
    opslag('localStorage', MANUAL_LOCALE_KEY, taal);
    if (land) opslag('localStorage', MANUAL_COUNTRY_KEY, land);
    var url = null;
    if (pad === 'nl') {
      /* Nederlands staat op oduree.nl (markt Nederland & België). */
      var nl = currentHost() === 'oduree.nl' ? location.href : (linkVoor('nl') || 'https://oduree.nl/');
      url = metParams(nl, NL_LANDEN[land] ? { country: land, 'odu-keuze': 'nl' } : { 'odu-keuze': 'nl' });
    } else {
      var land2 = doelLand(land);
      var href = currentHost() === 'oduree.com' && huidigeTaal() === pad ? location.href : linkVoor(pad);
      /* Bestaat die taal (nog) niet als versie van deze pagina, dan Engels. */
      if (!href) { pad = 'en'; href = currentHost() === 'oduree.com' && huidigeTaal() === 'en' ? location.href : linkVoor('en'); }
      if (!href) href = 'https://oduree.com/';
      var params = { 'odu-keuze': pad };
      if (land2) params.country = land2;
      /* Het gekozen land gaat mee naar het andere domein, zodat de kiezer daar ook dat land toont
         (Nederland of België op oduree.com staat bij Shopify als Ierland: zelfde euro, geen omleiding). */
      if (land) params['odu-thuis'] = land;
      url = metParams(href, params);
    }
    if (url) window.location.assign(url);
  }
  /* De taal die bij een land hoort (browsertaal beslist in meertalige landen), voor het venster. */
  function taalVoorLand(land) { return doelTaal(String(land || '').toUpperCase()); }
  /* Het land om te tonen: wie zelf Nederland of België koos en oduree.com in een andere taal gebruikt, staat bij
     Shopify als Ierland (zelfde euro). Toon dan gewoon het gekozen land. */
  function weergaveLand(shopifyLand) {
    var gekozen = String(opslag('localStorage', MANUAL_COUNTRY_KEY) || '').toUpperCase();
    if (currentHost() === 'oduree.com' && String(shopifyLand).toUpperCase() === 'IE' && NL_LANDEN[gekozen]) return gekozen;
    return shopifyLand;
  }
  window.OdureeLocatie = { kies: kies, taalVoorLand: taalVoorLand, weergaveLand: weergaveLand };

  /* Kiest de bezoeker zelf een taal, dan onthouden: daarna nooit meer op locatie doorsturen. */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('button[name="locale_code"], [data-oduree-language-host]');
    if (!knop) return;
    opslag('localStorage', MANUAL_LOCALE_KEY, knop.value || knop.getAttribute('data-oduree-language-host') || '1');
  }, true);

  // Capture-fase, zodat we vóór de listbox-handlers van het thema lopen
  document.addEventListener('click', onCountryClick, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-oduree-language-host]');
    if (!btn) return;
    var url = otherDomainUrl(btn.getAttribute('data-oduree-language-host'));
    if (!url) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = url;
  }, true);

  /* Eerst de taal (dat is een andere pagina); daarna pas de munt, op de pagina waar de bezoeker blijft. */
  routeByLocation(function () {});
})();
